import { Mail } from 'lucide-react';
import { LandingHeader } from '@/components/LandingHeader';
import { LandingFooter } from '@/components/LandingFooter';
import { useTranslation } from '@/hooks/useTranslation';
import { Reveal, SpotlightCard } from '@/components/landing/motion-primitives';
import { PageHero, PrimaryCta, Section } from '@/components/landing/page-kit';

export default function PressPage() {
  const { language, t } = useTranslation();
  const fr = language === 'fr';

  return (
    <div className="min-h-screen bg-background text-foreground">
      <LandingHeader />

      <main>
        <PageHero
          eyebrow={fr ? 'Presse' : 'Press'}
          title={t('press.title' as any)}
          subtitle={
            fr
              ? 'Articles, interviews et actualités sur clevia.'
              : 'Articles, interviews and news about clevia.'
          }
        />

        {/* ── Contact presse ─────────────────────────────────────── */}
        <Section width="narrow" className="pt-0 lg:pt-0">
          <Reveal>
            <SpotlightCard className="rounded-xl border border-border bg-card p-8 sm:p-10">
              <Mail className="h-5 w-5 text-primary" />
              <h2 className="mt-5 text-balance text-2xl font-semibold tracking-tight">
                {fr
                  ? 'Envie de parler de clevia avec nous ?'
                  : 'Want to talk about clevia with us?'}
              </h2>
              <p className="mt-4 text-pretty leading-relaxed text-muted-foreground">
                {fr
                  ? "Vous êtes journaliste, créateur de contenu ou simplement curieux de ce que nous construisons ? On serait ravis d'échanger avec vous. On aime parler d'argent, d'idées et de la façon dont on peut rendre tout ça plus simple."
                  : 'Are you a journalist, content creator or simply curious about what we are building? We would be delighted to chat with you. We love talking about money, ideas and how we can make it all simpler.'}
              </p>

              <div className="mt-8">
                <p className="text-[11px] font-medium uppercase tracking-[0.22em] text-muted-foreground">
                  {fr ? 'Écrivez-nous directement' : 'Write to us directly'}
                </p>
                <div className="mt-4">
                  <PrimaryCta href="mailto:founders@cleviaapp.com" fullWidthOnMobile={false}>
                    founders@cleviaapp.com
                  </PrimaryCta>
                </div>
              </div>
            </SpotlightCard>
          </Reveal>

          {/* ── À venir ──────────────────────────────────────────── */}
          <Reveal className="mt-16">
            <p className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-center text-sm text-muted-foreground">
              <span className="shrink-0 rounded-full border border-border px-3 py-1 text-[10px] font-medium uppercase tracking-[0.18em]">
                {fr ? 'Bientôt disponible' : 'Coming soon'}
              </span>
              {fr
                ? 'Retrouvez ici les articles, interviews et actualités sur clevia.'
                : 'Find here articles, interviews and news about clevia.'}
            </p>
          </Reveal>

          {/* ── Citation ─────────────────────────────────────────── */}
          <Reveal delay={0.1}>
            <figure className="mt-16 border-t border-border pt-16 text-center">
              <blockquote className="mx-auto max-w-2xl text-balance text-2xl font-medium leading-snug tracking-tight sm:text-3xl">
                «&nbsp;
                {fr ? 'On répond toujours avec plaisir.' : 'We always respond with pleasure.'}
                &nbsp;»
              </blockquote>
              <figcaption className="mt-6 text-sm text-muted-foreground">
                <span className="font-medium text-foreground">Mehdi &amp; Marouane</span>
                <span className="mt-1 block">
                  {fr ? 'Fondateurs de clevia' : 'Founders of clevia'}
                </span>
              </figcaption>
            </figure>
          </Reveal>
        </Section>
      </main>

      <LandingFooter />
    </div>
  );
}
